<template>
  <div class="table no-treeview table-bg">
    <div class="table-header center">
      <div class="table-tlt center-left">
        <h2>처리 결과 리스트</h2>
      </div>
      <div v-if="loading === false" class="strong-text center">
        ( 총 결제: {{ Number(pagination.total).toLocaleString() }}건 )
      </div>
      <div class="table-btn center-right">
        <div class="btn-renew" @click="refreshList">
          <button class="btn btn-40"><span><img src="/static/img/ico-renew@2x.png" alt=""></span></button>
        </div>
        <div class="btn-export-excel" @click="downloadExcel">
          <button class="btn btn-40"><span><img src="/static/img/ico_excel@2x.png" alt=""></span></button>
        </div>
      </div>
    </div>
    <div class="table-desc search">
      <table v-if="searchType==='claim'">
        <tr class="header">
          <th>처리 날짜</th>
          <th>상태</th>
          <th>고객 이름</th>
          <th>고객 전화번호</th>
          <th>취소 금액</th>
          <th>재승인 금액</th>
          <th>메모</th>
        </tr>
        <tr v-for="item in list" :key="item.ID">
          <td>
            <div>{{ item.createdDate }}</div>
            <div class="time">{{ item.createdTime }}</div>
          </td>
          <td>
            <div>{{ item.state }}</div>
          </td>
          <td>
            <div>{{ item.userName }}</div>
          </td>
          <td>
            <div>{{ item.userMobile }}</div>
          </td>
          <td>
            <div>{{ item.cancelPrice }}</div>
          </td>
          <td>
            <div>{{ item.rebillPrice }}</div>
          </td>
          <td>
            <div>{{ item.memo }}</div>
          </td>
        </tr>
      </table>

      <table v-else-if="searchType==='refund'">
        <tr class="header">
          <th>처리 날짜</th>
          <th>상태</th>
          <th>고객 이름</th>
          <th>고객 전화번호</th>
          <th>환불 금액</th>
          <th>은행이름</th>
          <th>계좌번호</th>
          <th>예금주</th>
          <th>메모</th>
        </tr>
        <tr v-for="item in list" :key="item.ID">
          <td>
            <div>{{ item.createdDate }}</div>
            <div class="time">{{ item.createdTime }}</div>
          </td>
          <td>
            <div>{{ item.state }}</div>
          </td>
          <td>
            <div>{{ item.userName }}</div>
          </td>
          <td>
            <div>{{ item.userMobile }}</div>
          </td>
          <td>
            <div>{{ item.refundPrice }}</div>
          </td>
          <td>
            <div>{{ item.bankName }}</div>
          </td>
          <td>
            <div>{{ item.bankAccountNumber }}</div>
          </td>
          <td>
            <div>{{ item.bankAccountHolder }}</div>
          </td>
          <td>
            <div>{{ item.memo }}</div>
          </td>
        </tr>
      </table>

      <table v-if="searchType==='nonpayment'">
        <tr class="header">
          <th>처리 날짜</th>
          <th>상태</th>
          <th>고객 이름</th>
          <th>고객 전화번호</th>
          <th>결제 금액</th>
          <th>메모</th>
        </tr>
        <tr v-for="item in list" :key="item.ID">
          <td>
            <div>{{ item.createdDate }}</div>
            <div class="time">{{ item.createdTime }}</div>
          </td>
          <td>
            <div>{{ item.state }}</div>
          </td>
          <td>
            <div>{{ item.userName }}</div>
          </td>
          <td>
            <div>{{ item.userMobile }}</div>
          </td>
          <td>
            <div>{{ item.paymentPrice }}</div>
          </td>
          <td>
            <div>{{ item.memo }}</div>
          </td>
        </tr>
      </table>

      <div class="pagination" v-if="pagination.total > 0">
        <span class="pagination-prev" @click="goPrev">
          <img src="/static/img/ico-arrow-line.png" alt />
        </span>

        <span v-if="pagination.pageArray[0] > 1" @click="goPage(1)">1</span>
        <span v-if="pagination.pageArray[0] > 1" @click="jumpPrev">...</span>
        <span
          v-for="n in pagination.pageArray"
          :key="n"
          :class="n === pagination.page ? 'page-num current' : 'page-num'"
          @click="goPage(n)"
          >{{ n }}
        </span>
        <span
          v-if="
            pagination.pageArray[pagination.pageArray.length - 1] <
            pagination.length
          "
          @click="jumpNext"
          >...
        </span>
        <span
          v-if="
            pagination.pageArray[pagination.pageArray.length - 1] <
            pagination.length
          "
          @click="goPage(pagination.length)"
          >{{ pagination.length }}
        </span>

        <span class="pagination-next" @click="goNext">
          <img src="/static/img/ico-arrow-line.png" alt />
        </span>

        <input
          type="number"
          v-model="pagination.input"
          @keyup.enter="goPage(Number(pagination.input))"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable no-await-in-loop */

import Configuration from '@/js/Configuration';
import js2excel from 'js2excel'; // https://github.com/dwqs/js2excel

export default {
  props: ['searchCondition', 'searchEvent', 'startTime', 'endTime', 'searchType', 'downloadEvent'],
  data: () => ({
    list: [],
    pagination: {
      page: 1,
      total: 0,
      length: 1,
      perPage: 10,
      perLength: 5,
      pageArray: [],
      input: 1,
    },
    loading: true,
    downloadFileName: 'cella-claim',
  }),
  created() {
    /*
    this.getList(false);
    */
  },
  watch: {
    searchEvent: {
      handler() {
        this.pagination.page = 1;
        this.pagination.input = 1;
        this.pagination.total = 0;
        this.pagination.length = 1;

        this.getList(false);
      },
    },
    downloadEvent: {
      handler() {
        this.downloadExcel();
      },
    },
  },
  methods: {
    refreshList() {
      this.getList(false);
    },
    async getCount() {
      try {
        let countURL = `${Configuration.value(
          'CPAYMENT_ADDRESS',
        )}/api/v1/cpayment/user/claim/count?test=dump`;
        if (this.searchType === 'claim') {
          countURL += '&state=105&state=112&state=115';
        } else if (this.searchType === 'refund') {
          countURL += '&state=122';
        } else if (this.searchType === 'nonpayment') {
          countURL += '&state=135';
        }
        if (this.searchCondition) {
          countURL += `&${this.searchCondition}`;
        }
        const count = await this.$http.get(countURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (count.status !== 200) {
          throw new Error(`Response status is "${count.status}"`);
        }
        if (count.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${count.data.resultCode}"`);
        }
        if (count.data.count < 1) {
          this.pagination.page = 1;
          this.pagination.total = 0;
          this.pagination.length = 1;
          this.loading = false;
          return this.pagination.total;
        }

        this.pagination.total = count.data.count;
        this.pagination.length = Math.ceil(
          this.pagination.total / this.pagination.perPage,
        );

        const pageBack = Math.floor((this.pagination.perLength - 1) / 2);
        const pageForward = this.pagination.perLength - 1 - pageBack;
        let firstPage = this.pagination.page - pageForward;
        let lastPage = this.pagination.page + pageBack;
        if (firstPage < 1) {
          firstPage = 1;
          lastPage = this.pagination.perLength;
        }
        if (lastPage > this.pagination.length) {
          lastPage = this.pagination.length;
        }
        if (lastPage - firstPage + 1 < this.pagination.perLength) {
          if (firstPage > 1) {
            firstPage -= this.pagination.perLength - lastPage + firstPage - 1;
            if (firstPage < 1) {
              firstPage = 1;
            }
          } else if (lastPage < this.pagination.length) {
            lastPage += this.pagination.perLength - lastPage + firstPage - 1;
            if (lastPage > this.pagination.length) {
              lastPage = this.pagination.length;
            }
          }
        }

        this.pagination.pageArray = [];
        for (let i = firstPage; i <= lastPage; i++) {
          this.pagination.pageArray.push(i);
        }
      } catch (e) {
        this.pagination.page = 1;
        this.pagination.total = 0;
        this.pagination.length = 1;
        this.list = [];
        this.loading = false;

        alert('정보를 가져오지 못했습니다.\n잠시후 다시 시도해주세요.');
        console.error(e);
      }
      return this.pagination.total;
    },
    async getList(forDownload) {
      this.loading = true;
      const list = [];
      if (!forDownload) {
        this.list = [];
        this.pagination.input = this.pagination.page;
        await this.getCount();
      }
      try {
        let num =
          this.pagination.total -
          (this.pagination.page - 1) * this.pagination.perPage;

        let keyiv = '';
        let encKey = '';
        if (!Configuration.valueBool('IS_STAGE')) {
          keyiv = this.$generateAESKeyAndIV(32, 12);
          encKey = this.$jsEncrypt.encrypt(`${keyiv.key}${keyiv.iv}`);
        }

        let listURL = `${Configuration.value(
          'CPAYMENT_ADDRESS',
        )}/api/v1/cpayment/user/claim/list?page=${this.pagination.page}&limit=${
          this.pagination.perPage
        }`;
        if (this.searchType === 'claim') {
          listURL += '&state=105&state=112&state=115';
        } else if (this.searchType === 'refund') {
          listURL += '&state=122';
        } else if (this.searchType === 'nonpayment') {
          listURL += '&state=135';
        }
        if (this.searchCondition) {
          listURL += `&${this.searchCondition}`;
        }
        const resList = await this.$http.get(listURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            sKey: encKey,
          },
        });
        if (resList.status !== 200) {
          if (resList.status === 204) {
            this.pagination.page = 1;
            this.pagination.total = 0;
            this.pagination.length = 1;
            this.loading = false;
            return list;
          }

          throw new Error(`response status is "${resList.status}"`);
        }
        if (resList.data.resultCode !== '0000') {
          throw new Error(`resultcode is "${resList.data.resultCode}"`);
        }

        for (let i = 0; i < resList.data.userClaims.length; i++) {
          const it = resList.data.userClaims[i];

          const state = this.$getConstName('state', it.state);
          let ban = '-';
          if (it.bankAccountNumber.length > 0) {
            if (!Configuration.valueBool('IS_STAGE')) {
              ban = await this.$decryptGCM(keyiv.key, keyiv.iv, it.bankAccountNumber);
            } else {
              ban = it.bankAccountNumber;
            }
          } else {
            ban = '-';
          }

          const item = {
            num,
            ID: it.paymentID,
            createdAt: it.createdAt,
            createdDate: this.$moment(it.createdAt).format('YYYY.MM.DD'),
            // createdTime: this.$moment(it.createdAt).format('hh:mm A'),
            createdTime: this.$moment(it.createdAt).format('HH:mm:ss'),
            state,
            userName: it.userName,
            userMobile: it.userMobile,
            cancelPrice: it.cancelPrice,
            rebillPrice: it.rebillPrice,
            refundPrice: it.refundPrice,
            paymentPrice: it.paymentPrice,
            memo: it.memo,
            bankName: it.bankName,
            bankAccountNumber: ban,
            bankAccountHolder: it.bankAccountHolder,
          };
          list.push(item);

          num--;
        }

        if (!forDownload) {
          this.list = list;
        }
        this.loading = false;
      } catch (e) {
        this.pagination.page = 1;
        this.pagination.total = 0;
        this.pagination.length = 1;
        this.list = [];
        this.loading = false;

        alert('정보를 가져오지 못했습니다.\n잠시후 다시 시도해주세요.');
        console.error(e);
      }

      return list;
    },
    goPrev() {
      if (this.pagination.page <= 1) {
        return;
      }
      this.pagination.page--;

      this.getList(false);
    },
    goNext() {
      if (this.pagination.page >= this.pagination.length) {
        return;
      }
      this.pagination.page++;

      this.getList(false);
    },
    jumpPrev() {
      if (
        Array.isArray(this.pagination.pageArray) &&
        this.pagination.pageArray.length > 0
      ) {
        this.pagination.page = this.pagination.pageArray[0];
        this.pagination.page--;
      } else {
        this.pagination.page = 1;
      }

      if (this.pagination.page < 1) {
        this.pagination.page = 1;
      }

      this.getList(false);
    },
    jumpNext() {
      if (
        Array.isArray(this.pagination.pageArray) &&
        this.pagination.pageArray.length > 0
      ) {
        this.pagination.page = this.pagination.pageArray[
          this.pagination.pageArray.length - 1
        ];
        this.pagination.page++;
      } else {
        this.pagination.page = 1;
      }

      if (this.pagination.page > this.pagination.length) {
        this.pagination.page = this.pagination.length;
      }

      this.getList(false);
    },
    goPage(page) {
      if (page < 1) {
        page = 1;
      }
      if (page > this.pagination.length) {
        page = this.pagination.length;
      }
      this.pagination.page = page;
      this.getList(false);
    },
    async downloadExcel() {
      try {
        const perPage = this.pagination.perPage;
        const page = this.pagination.page;
        const input = this.pagination.input;
        const total = this.pagination.total;
        const length = this.pagination.length;

        const companyList = {};
        const claims = [];
        this.pagination.perPage = 500;
        for (this.pagination.page = 1; this.pagination.page < 500; this.pagination.page++) {
          const list = await this.getList(true);
          if (list.length === 0) {
            break;
          }
          for (let i = 0; i < list.length; i++) {
            const it = list[i];

            //
            let registrationNo = '';
            let companyName = '';
            let paymentAt = '-';
            let approveAt = '-';
            let createdAt = '-';
            let paymentDetail = null;
            const payment = await this.$getPayment(it.ID);
            if (payment) {
              if (!companyList[payment.companyID]) {
                const company = await this.$getCompany(payment.companyID, false, false);
                if (company) {
                  companyList[payment.companyID] = company;
                  registrationNo = company.registrationNo;
                  companyName = company.companyName;
                }
              } else {
                registrationNo = companyList[payment.companyID].registrationNo;
                companyName = companyList[payment.companyID].companyName;
              }

              /*
              paymentAt = payment.paymentAt ? `${this.$moment(payment.paymentAt).format('YYYY.MM.DD')} ${this.$moment(payment.paymentAt).format('hh:mm A')}` : '-';
              approveAt = payment.approveAt ? `${this.$moment(payment.approveAt).format('YYYY.MM.DD')} ${this.$moment(payment.approveAt).format('hh:mm A')}` : '-';
              createdAt = it.createdAt ? `${this.$moment(it.createdAt).format('YYYY.MM.DD')} ${this.$moment(it.createdAt).format('hh:mm A')}` : '-';
              */
              paymentAt = payment.paymentAt ? `${this.$moment(payment.paymentAt).format('YYYY.MM.DD')} ${this.$moment(payment.paymentAt).format('HH:mm:ss')}` : '-';
              approveAt = payment.approveAt ? `${this.$moment(payment.approveAt).format('YYYY.MM.DD')} ${this.$moment(payment.approveAt).format('HH:mm:ss')}` : '-';
              createdAt = it.createdAt ? `${this.$moment(it.createdAt).format('YYYY.MM.DD')} ${this.$moment(it.createdAt).format('HH:mm:ss')}` : '-';
              if (payment.paymentDetails) {
                let productCount = 0;
                for (let j = 0; j < payment.paymentDetails.length; j++) {
                  const pd = payment.paymentDetails[j];
                  productCount += pd.productCount;
                }
                if (productCount === 1) {
                  // paymentDetail = `${payment.paymentDetails[0].productName.substr(0, 4)}`;
                  paymentDetail = `${payment.paymentDetails[0].productName}`;
                } else if (productCount > 1) {
                  // paymentDetail = `${payment.paymentDetails[0].productName.substr(0, 2)} 외 ${productCount - 1} 개`;
                  paymentDetail = `${payment.paymentDetails[0].productName} 외 ${productCount - 1} 개`;
                }
              }
            }

            const c = {
              사업자번호: registrationNo,
              회사이름: companyName,
              거래날짜: paymentAt,
              승인날짜: approveAt,
              거절사유: payment.resultMsg,
              처리날짜: createdAt,
              결제상품: paymentDetail,
              paymentID: it.ID,
              state: it.state,
              userName: it.userName,
              userMobile: it.userMobile,
              cancelPrice: it.cancelPrice,
              rebillPrice: it.rebillPrice,
              refundPrice: it.refundPrice,
              paymentPrice: it.paymentPrice,
              memo: it.memo,
              bankName: it.bankName,
              bankAccountNumber: it.bankAccountNumber,
              bankAccountHolder: it.bankAccountHolder,
            };
            claims.push(c);
          }
        }
        if (claims.length === 0) {
          alert('다운로드할 내용이 없습니다.');
          this.$emit('downloaded');
          return;
        }
        this.pagination.perPage = perPage;
        this.pagination.page = page;
        this.pagination.input = input;
        this.pagination.total = total;
        this.pagination.length = length;

        js2excel.json2excel({
          data: claims,
          name: this.downloadFileName,
          formateDate: 'yyyy/mm/dd',
        });
      } catch (e) {
        console.error('downloadExcel error', e);
      }

      this.$emit('downloaded');
      /*
      // for webpack 3: dynamic import
      // webpackChunkName: "js2excel"
      import('js2excel').then(({ json2excel }) => {
        json2excel({
          data: this.list,
          name: this.downloadFileName,
          formateDate: 'dd/mm/yyyy',
        });
      }).catch((e) => {

      });
      */
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/claim/ClaimResultList.vue